import { columnTypes, dataTypes } from 'cat-ecommerce-alloy';

export const getTableSchema = (t, isSM, isValidParts) => {
  const displayOnDesktopOnly = 'd-none d-md-table-cell';
  const displayOnDesktopAndMobile = 'd-table-cell';
  const width = !isSM ? 'w-75' : '';
  const quantityPadding = isValidParts ? '' : 'pt-3 pt-md-2';
  return [
    {
      className: `${displayOnDesktopAndMobile} ${quantityPadding}`,
      id: 'quantity',
      label: t('QUANTITY1'),
      columnType: columnTypes.HUGGED,
      isSortable: false
    },
    {
      className: `${displayOnDesktopAndMobile} ${width}`,
      id: 'partNumber',
      label: `${t('ITEM_NUMBER')}*`,
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.ALPHANUMERIC,
      isSortable: false
    },
    {
      id: 'assetId',
      label: t('ASSET_ID_ESN'),
      columnType: columnTypes.STRETCHED,
      dataType: dataTypes.ALPHANUMERIC,
      isSortable: false,
      className: displayOnDesktopOnly
    },
    {
      className: isValidParts ? 'd-none' : displayOnDesktopAndMobile,
      id: 'actions',
      dataType: dataTypes.ICON,
      columnType: columnTypes.HUGGED
    }
  ];
};
